import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-marquee',
  templateUrl: './marquee.component.html',
  styleUrls: ['./marquee.component.scss']
})
export class MarqueeComponent implements OnInit {
    @Input() duration = '120s';
    @Input() show = true;

  ngOnInit(): void {
  }

}
